import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import DownloadIcon from "@mui/icons-material/Download";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import { useState } from "react";

const RevenueList = () => {

  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");

  const rows = [
    {
      id: 1,
      customerName: "Madelyn Dias",
      email: "madelyndias@gmail.com",
      plan: "Premium Monthly",
      amount: "AED 199",
      method: "American Express My Zone Card",
      cardLast4: "5678",
      date: "01 March 2025",
      status: "Paid",
    },
    {
      id: 2,
      customerName: "Alex Turner",
      email: "alex.t@gmail.com",
      plan: "Basic Yearly",
      amount: "AED 999",
      method: "Cash",
      cardLast4: "",
      date: "15 March 2025",
      status: "Paid",
    },
  ];

  return (
    <>
      <div className="table_header">
        <div className="left_s">
          <Box className="search_box">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder="Search..."
            />
          </Box>
          <Box className="form">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                className="form_control"
                slots={{
                  openPickerIcon: () => <img src="/static/images/date_icon.svg" alt="icon" />,
                }}
                slotProps={{
                  textField: {
                    placeholder: "Select Date",
                    fullWidth: true,
                    hiddenLabel: true
                  },
                }}
                desktopModeMediaQuery="(min-width:0px)"
              />
            </LocalizationProvider>
          </Box>
        </div>
        <div className="right_s">
          <Button className="btn btn_primary"><DownloadIcon /> Export</Button>
        </div>
      </div>
      <TableContainer className="table_container">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Customer Detail</TableCell>
              <TableCell>Subscription Plan</TableCell>
              <TableCell>Amount</TableCell>
              <TableCell>Payment Method</TableCell>
              <TableCell>Date</TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow hover key={row.id}>
                <TableCell>
                  <a
                    href="/manage-users/detail"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/manage-users/detail", { state: { user: row } });
                    }}
                    className="user_block click_action"
                  >
                    <figure>
                      <img
                        src="/static/images/user_placeholder.png"
                        alt={`${row.customerName}'s profile`}
                        width={40}
                      />
                    </figure>
                    <p>
                      <b>{row.customerName}</b>
                      <span>{row.email}</span>
                    </p>
                  </a>

                </TableCell>
                <TableCell>{row.plan}</TableCell>
                <TableCell>{row.amount}</TableCell>
                <TableCell>
                  <div className="user_block">
                    <p>
                      <b>{row.method}</b>
                      {row.cardLast4 && (
                        <span>xxxx xxxx xxxx {row.cardLast4}</span>
                      )}
                    </p>
                  </div>
                </TableCell>
                <TableCell>{row.date}</TableCell>
                <TableCell>
                  <span className="status_btn c_success">{row.status}</span>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default RevenueList;
